import type { ConsentRecord } from "./consent-store";

export type { ConsentRecord };

/** Minimal reader contract — the consent store, or a test double. */
type ConsentReader = {
  getStoredConsent: () => ConsentRecord | null;
};

/** Minimal analytics contract — the PostHog singleton, or a test double. */
type AnalyticsClient = {
  init: (consentAnalytics: boolean) => void;
};

/**
 * Boots analytics already in the correct consent state. The persisted choice is
 * the single source of truth: PostHog is initialized with capture ON only when a
 * valid record explicitly accepted analytics; anything else (no record, refused,
 * corrupt, version bump ⇒ `null`) initializes opt-out + memory. The read is
 * synchronous and precedes `init()`, so there is no window in which a request
 * could fire before the consent state is known (SPEC AC 1-2, 10).
 */
export function bootAnalyticsWithConsent(
  store: ConsentReader,
  client: AnalyticsClient,
): void {
  const record = store.getStoredConsent();
  client.init(record?.analytics === true);
}
